// Copyright (c) 2026 Yunus YILDIZ — SPDX-License-Identifier: BUSL-1.1
// Access token stored in memory (XSS-safe); refresh token in sessionStorage

const REFRESH_TOKEN_KEY = 'sdf_rt'

let _accessToken: string | null = null

export const tokenStorage = {
  getAccessToken(): string | null {
    return _accessToken
  },

  setAccessToken(token: string): void {
    _accessToken = token
  },

  clearAccessToken(): void {
    _accessToken = null
  },

  getRefreshToken(): string | null {
    return sessionStorage.getItem(REFRESH_TOKEN_KEY)
  },

  setRefreshToken(token: string): void {
    sessionStorage.setItem(REFRESH_TOKEN_KEY, token)
  },

  clearRefreshToken(): void {
    sessionStorage.removeItem(REFRESH_TOKEN_KEY)
  },

  clearAll(): void {
    _accessToken = null
    sessionStorage.removeItem(REFRESH_TOKEN_KEY)
  },
}
